import React, { createContext, useState, useEffect } from "react"
import UserTableTitle from "../../constants/UserTableTitle.json"
import API from "../../api/api"
import TestuserData from "../../test/userList.json"
import { db } from "../../helpers/firebase_helper"

export const UserListContext = createContext()

export const UserListContextProvider = ({ children }) => {
  const [userData, setUserData] = useState([])
  const [totalPagesCount, setTotalPagesCount] = useState(0)
  const [userDataBackup, setUserDataBackup] = useState()
  const [pageNumberThreshold, setPageNumberThreshold] = useState(0)

  /**
   * Get users list from db
   */
  const getUserList = async () => {
    let fullUserList = []
    const snapshot = await db.collection("users").get()
    snapshot.forEach(doc => {
      const snapshotDashboard = doc
      const userDoc = { ...snapshotDashboard.data(), id: doc.id }
      fullUserList.push(userDoc)
    })
    
    const totalPages = Math.ceil(fullUserList.length / 10)
    setPageNumberThreshold(0)
    setTotalPagesCount(totalPages)
    setUserDataBackup(fullUserList)
    setUserData(fullUserList.slice(0, 10))
  }

  useEffect(() => {
    getUserList()
  }, [])

  const nextPage = async currentPageNumber => {
    setPageNumberThreshold((currentPageNumber - 1) * 10)
    const startIndex = (currentPageNumber - 1) * 10
    const endIndex = currentPageNumber * 10
    const results = userDataBackup.slice(startIndex, endIndex)
    setUserData(results)
  }

  const providerValue = {
    userData,
    UserTableTitle,
    nextPage,
    totalPagesCount,
    pageNumberThreshold,
  }

  return (
    <UserListContext.Provider value={providerValue}>
      {children}
    </UserListContext.Provider>
  )
}
